import CertificationDTO from "../dto/CertificationDTO";
import ApiResponseV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/ApiResponseV2";
import PagedResult from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/core/PagedResult";
import GenericCrudServiceV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/services/GenericCrudServiceV2";
import HttpClientV2 from "../external/ensolvers-core-frontend-mui/submodules/fox-typescript/utils/HttpClientV2";
import Certification from "../models/Certification";

class CertificationService extends GenericCrudServiceV2<Certification> {
  readonly path: string;

  constructor(path: string) {
    super(path);
    this.path = path;
  }

  apply(badgeExternalId: string): Promise<ApiResponseV2<CertificationDTO>> {
    return HttpClientV2.post(`${this.basePath}/badges/${badgeExternalId}/start-certification`, {});
  }

  findFiltered(
    page: number,
    pageSize: number,
    badgeExternalId: string,
    search: string,
    status: string,
    level: string,
  ): Promise<ApiResponseV2<PagedResult<Certification>>> {
    return HttpClientV2.get(
      `${this.basePath}/filtered?page=${page}&pageSize=${pageSize}&badgeExternalId=${badgeExternalId}&search=${search}&status=${status}&level=${level}`,
    );
  }

  createCertification(certification: Certification): Promise<ApiResponseV2<string>> {
    return HttpClientV2.post(`${this.basePath}/create`, certification);
  }

  changeStatus(certificationExternalId: string, status: string): Promise<ApiResponseV2<Certification>> {
    return HttpClientV2.put(`${this.basePath}/status?certificationId=${certificationExternalId}&status=${status}`, true);
  }
}

export default new CertificationService("certifications");
